import React, { Component } from 'react';
import { Modal, Tooltip, OverlayTrigger } from 'react-bootstrap';
import QcRangeDetails from './qcRangeDetails';
import Swal from 'sweetalert2';
import { ModalStyled } from '../../../../theme/customizedStyleComponents';
import { deleteQcRange } from '../../../../services/clinicPortalServices/qcRangeService';
import { Checkbox } from '@mui/material';

export default class EditBtnCellRenderer extends Component {
    constructor(props) {
        super(props);

        this.state = {
            show: false,
            qcRangeId: props.data._id
        };
    }

    handleDelete = () => {
        Swal.fire({
            title: 'Are you sure?',
            text: 'You will not be able to recover this anlayte!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, keep it',
            customClass: {
                container:
                    window.localStorage.getItem('appTheme') === 'Dark' &&
                    /clinic|lims/.test(window.location.pathname.split('/')[1]) &&
                    'dark-swal',
                cancelButton: 'order-1',
                confirmButton: 'order-2'
            }
        }).then((result) => {
            if (result.isConfirmed) {
                deleteQcRange({
                    _id: this.state.qcRangeId,
                    name: this.props.data.name
                }).then((res) => {
                    this.props.context.componentParent.loadGridData();
                });
            }
        });
    };

    handleShow = () => {
        this.setState({ show: true });
    };

    handleClose = () => {
        this.setState({ show: false });
    };

    renderTooltipEdit = (props) => (
        <Tooltip id="button-tooltip" {...props}>
            Edit QC Range
        </Tooltip>
    );

    renderTooltipDelete = (props) => (
        <Tooltip id="button-tooltip" {...props}>
            Delete QC Range
        </Tooltip>
    );

    renderTooltipCheckBulk = (props) => (
        <Tooltip id="button-tooltip" {...props}>
            Select to Create QC Sample
        </Tooltip>
    );

    handleBulkChecked = () => {
        this.props.context.componentParent.handleBulkChecked(this.props.data._id);
    };

    render() {
        return (
            <div>
                <OverlayTrigger placement="top" delay={{ show: 50, hide: 100 }} overlay={this.renderTooltipEdit}>
                    <button onClick={this.handleShow} className="edit-order-btn">
                        <i className="fas fa-pen"></i>
                    </button>
                </OverlayTrigger>
                <OverlayTrigger placement="top" delay={{ show: 50, hide: 100 }} overlay={this.renderTooltipDelete}>
                    <button onClick={this.handleDelete} className="edit-order-btn">
                        <i className="fas fa-trash"></i>
                    </button>
                </OverlayTrigger>
                {this.props.context.componentParent &&
                    this.props.context.componentParent.state &&
                    this.props.context.componentParent.state.isBulkSelect && (
                        <OverlayTrigger
                            placement="top"
                            delay={{ show: 50, hide: 100 }}
                            overlay={this.renderTooltipCheckBulk}
                        >
                            <Checkbox
                                checked={this.props.context.componentParent.state.bulkCheckedIds.includes(
                                    this.props.data._id
                                )}
                                onClick={() => this.handleBulkChecked()}
                            ></Checkbox>
                        </OverlayTrigger>
                    )}

                <ModalStyled
                    size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    show={this.state.show}
                    onHide={this.handleClose}
                    backdrop="static"
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Update QC Range Information</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <QcRangeDetails
                            qcRangeId={this.state.qcRangeId}
                            context={this.props.context}
                            handleClose={this.handleClose}
                        />
                    </Modal.Body>
                </ModalStyled>
            </div>
        );
    }
}
